import React, {useState} from 'react'
import {Modal, message} from 'antd'
import gql from 'graphql-tag'
import {useMutation} from '@apollo/react-hooks'
import {Redirect} from 'react-router-dom'
import flatMap from 'lodash.flatmap'
import Button from 'components/shared/Button'

const revertPostponedBookingsMutation = gql`
  mutation RevertPostponedBookings($estateId: ID!) {
    RevertPostponedBookings(estateId: $estateId) {
      estate {
        id
        postponedBookings {
          id
          products {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`

const PostponedBookingAlert = ({webOrder}) => {
  const [hasClosedModal, setHasClosedModal] = useState(false)
  const [redirectToEstate, setRedirectToEstate] = useState(false)
  const [revertPostponedBookings, {loading}] = useMutation(revertPostponedBookingsMutation)

  const hasPostponedBooking = webOrder.estate && webOrder.estate.postponedBookings.length > 0
  const postponedProducts = webOrder.estate
    ? flatMap(webOrder.estate.postponedBookings, (booking) =>
        booking.products.edges.map(({node}) => node.name)
      )
    : []

  const showModal = hasPostponedBooking && !hasClosedModal

  const handleAction = () => {
    return revertPostponedBookings({
      variables: {
        estateId: webOrder.estate.id,
      }
    }).then(() => {
      message.success('Booking aktivert')
      setRedirectToEstate(true)
    })
    .catch(() => {
      message.error('Noe gikk galt ved aktivering av booking. Prøv igjen senere.')
    })
  }

  if (redirectToEstate) {
    return <Redirect to={`/oppdrag/${webOrder.estate.id}`} />
  }

  if (!hasPostponedBooking) return null

  return (
    <Modal
      visible={showModal}
      closable={true}
      maskClosable={false}
      title="Du har en åpen booking på dette oppdraget"
      footer={[
        <Button key="activate" type="primary" onClick={handleAction} disabled={loading}>
          Aktiver booking
        </Button>,
        <Button key="new" type="primary" onClick={() => setHasClosedModal(true)}  disabled={loading}>
          Ny bestilling
        </Button>,
      ]}
    >
      <p>Du har en åpen booking på dette oppdraget ({postponedProducts.join(', ')}).</p>
      <p>Trykk "Aktiver booking" for å aktivere denne slik at vår kundeservice kan gjennomføre bookingen, eller trykk "Ny bestilling" for å legge til ekstra bestilling.</p>
    </Modal>
  )
}

export default PostponedBookingAlert
